import SectionWrapper from '@/components/atoms/SectionWrapper';
import RequestsTable from '@/components/reports/orders/RequestsTable';
import { Stats } from '@/components/reports/orders/Stats';
import PeriodSelect from '@/components/reports/SharedComponents/PeriodSelect';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { resetOrdersFilters } from '@/store/slices/reportFiltersSlice';
import { setSearch, setPage, setModalId } from '@/store/slices/publicSlice';

export default function OrdersReport() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetOrdersFilters());
      dispatch(setSearch({ key: 'ordersReportSearch', value: '' }));
      dispatch(setPage(0));
      dispatch(setModalId(null));
    };
  }, [dispatch]);

  return (
    <SectionWrapper
      title={t('reports.orders.title', 'Orders reports')}
      desc={t(
        'reports.orders.pageDesc',
        'A comprehensive report view of all platform orders, providing insights into performance, status, revenue, and order trends over time.'
      )}
      actions={<PeriodSelect />}
    >
      <div className="space-y-6">
        <Stats />

        <RequestsTable />
      </div>
    </SectionWrapper>
  );
}
